import {
  getV1CompaniesCompanyIdLabels,
  GetV1CompaniesCompanyIdLabelsData,
  Label_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { Label } from '~hooks/useLabels/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Label_Read,
  Label,
  GetV1CompaniesCompanyIdLabelsData
> & { companyId: string };

export default function AutocompleteLabelsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteLabelsTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        // FIXME @todo TRE-12887 -> To be replaced with a proper typeahead endpoint when available
        request: getV1CompaniesCompanyIdLabels,
      }}
      parseFn={(item: Label_Read) => {
        const parsed = Label.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
